import { AccountTree } from '@mui/icons-material';
import { SoftwareComponentCreate } from './SoftwareComponentCreate';
import { SoftwareComponentEdit } from './SoftwareComponentEdit';
import { SoftwareComponentList } from './SoftwareComponentList';
import { SoftwareComponentShow } from './SoftwareComponentShow';
import { SubMenu } from '../../constants/SubMenu';

const SoftwareComponentResource = {
  name: 'software_components',
  options: {
    isVisible: (hasPermission: Function) => hasPermission('dev_options'),
    menu: SubMenu.Develop,
  },
  icon: AccountTree,
  list: SoftwareComponentList,
  show: SoftwareComponentShow,
  edit: SoftwareComponentEdit,
  create: SoftwareComponentCreate,
  recordRepresentation: (record: any) => record.name,
};

export default SoftwareComponentResource;
